import "core-js/modules/es6.function.name";
import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapActions } from 'vuex';
export default {
  name: "forgot",
  data: function data() {
    var _this = this;

    return {
      edit: false,
      nameTabs: "name1",
      enterButton: this.$t('loginArea.getvcode'),
      enterButton1: this.$t('loginArea.getvcode'),
      formMoblie: {
        mobile: "",
        code: "",
        password: "",
        password1: ""
      },
      formEmail: {
        email: "",
        code: "",
        password: "",
        password2: ""
      },
      butDisabled: false,
      butDisabled1: false,
      rules: {
        mobile: [{
          required: true,
          validator: function validator(rule, value, callback) {
            var myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;

            if (!value) {
              callback(new Error(_this.$t('loginArea.mobileInput')));
            } else if (!myreg.test(value)) {
              callback(new Error(_this.$t('loginArea.mobilenotice')));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        code: [{
          required: true,
          message: this.$t('loginArea.codeplaceholder'),
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: this.$t('loginArea.passwordNotNull'),
          trigger: 'blur'
        }],
        password1: [{
          required: true,
          validator: function validator(rule, value, callback) {
            if (!value) {
              callback(new Error(_this.$t('loginArea.inputAgainPass')));
            } else if (value !== _this.formMoblie.password) {
              callback(new Error(_this.$t('loginArea.comparePass')));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        password2: [{
          required: true,
          validator: function validator(rule, value, callback) {
            if (!value) {
              callback(new Error(_this.$t('loginArea.inputAgainPass')));
            } else if (value !== _this.formEmail.password) {
              callback(new Error(_this.$t('loginArea.comparePass')));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        email: [{
          required: true,
          message: this.$t('loginArea.emailNotNull'),
          trigger: 'blur'
        }, {
          type: 'email',
          message: this.$t('loginArea.emailIncorrect'),
          trigger: 'blur'
        }]
      },
      rules1: {
        mobile: [{
          required: true,
          validator: function validator(rule, value, callback) {
            var myreg = /^[1][3,4,5,7,8,9][0-9]{9}$/;

            if (!value) {
              callback(new Error(_this.$t('loginArea.mobileInput')));
            } else if (!myreg.test(value)) {
              callback(new Error(_this.$t('loginArea.mobilenotice')));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        code: [{
          required: true,
          message: this.$t('loginArea.codeplaceholder'),
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: this.$t('loginArea.passwordNotNull'),
          trigger: 'blur'
        }],
        password1: [{
          required: true,
          validator: function validator(rule, value, callback) {
            if (!value) {
              callback(new Error(_this.$t('loginArea.inputAgainPass')));
            } else if (value !== _this.formMoblie.password) {
              callback(new Error(_this.$t('loginArea.comparePass')));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        password2: [{
          required: true,
          validator: function validator(rule, value, callback) {
            if (!value) {
              callback(new Error(_this.$t('loginArea.inputAgainPass')));
            } else if (value !== _this.formEmail.password) {
              callback(new Error(_this.$t('loginArea.comparePass')));
            } else {
              callback();
            }
          },
          trigger: 'blur'
        }],
        email: [{
          required: true,
          message: this.$t('loginArea.emailNotNull'),
          trigger: 'blur'
        }, {
          type: 'email',
          message: this.$t('loginArea.emailIncorrect'),
          trigger: 'blur'
        }]
      }
    };
  },
  props: {},
  computed: {
    userInfoStore: function userInfoStore() {
      var data = this.$store.state.user.userInfo;
      return data;
    }
  },
  methods: _objectSpread({}, mapActions(['handleForgot']), {
    back: function back() {
      this.$router.push("/login");
    },
    clickChange: function clickChange(evt) {
      this.nameTabs = evt;
    },
    getCode: function getCode() {
      var _this2 = this;

      var time = 120,
          vm = this;
      var mobile = this.formMoblie.mobile,
          email = this.formEmail.mobile,
          mReg = /^[1][3,4,5,7,8,9][0-9]{9}$/,
          eReg = /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/,
          mob,
          mobTetx = "",
          url,
          params;

      if (this.nameTabs == "name1") {
        mob = !mReg.test(mobile);
        mobTetx = this.$t('loginArea.mobilenotice');
        url = "handleGetsms";
        params = {
          mobile: mobile,
          type: 2
        };
      } else {
        mob = !eReg.test(email);
        mobTetx = this.$t('loginArea.emailIncorrect');
        url = "handleGetEmall";
        params = {
          email: email,
          type: 2
        };
      }

      vm.$refs.formMoblie.validateField('mobile', function (valide) {
        if (valide === '') {
          mob = !mReg.test(mobile);
          mobTetx = vm.$t('loginArea.mobilenotice');
          url = "handleGetsms";
          params = {
            mobile: mobile,
            type: 2
          };

          var callback = function callback(res) {
            if (res.result === 0) {
              _this2.$Message.success(res.errorMsg);

              vm.butDisabled = true;
              var setinter = setInterval(function () {
                if (time > 0) {
                  time--;
                  vm.enterButton = time + vm.$t('loginArea.getVodeSecondAfter');
                } else {
                  vm.enterButton = vm.$t('loginArea.getvcode');
                  vm.butDisabled = false;
                  clearInterval(setinter);
                }
              }, 1000);
            } else {
              _this2.$Message.error(res.errorMsg);
            }
          };

          vm.$store.dispatch(url, params).then(function (res) {
            callback(res);
          });
        }
      });
    },

    /**
     * 邮箱获取验证码
     */
    getEmailCode: function getEmailCode() {
      var _this3 = this;

      debugger;
      var time = 120,
          vm = this;
      var email = this.formEmail.email,
          mobTetx = "",
          url,
          params;
      vm.$refs.formEmail.validateField('email', function (valide) {
        if (valide === '') {
          mobTetx = vm.$t('loginArea.emailIncorrect');
          url = "handleGetEmall";
          params = {
            email: email,
            type: 2
          };

          var callback = function callback(res) {
            if (res.result === 0) {
              vm.$Message.success(res.errorMsg);
              vm.butDisabled1 = true;
              var setinter = setInterval(function () {
                if (time > 0) {
                  time--;
                  vm.enterButton1 = time + vm.$t('loginArea.getVodeSecondAfter');
                } else {
                  vm.enterButton1 = vm.$t('loginArea.getvcode');
                  vm.butDisabled1 = false;
                  clearInterval(setinter);
                }
              }, 1000);
            } else {
              _this3.$Message.error(res.errorMsg);
            }
          };

          vm.$store.dispatch(url, params).then(function (res) {
            callback(res);
          });
        }
      });
    },
    submit: function submit() {
      var _this4 = this;

      var _this$formMoblie = this.formMoblie,
          mobile = _this$formMoblie.mobile,
          code = _this$formMoblie.code,
          password = _this$formMoblie.password,
          org_code = _this$formMoblie.org_code;
      var sendtype;
      var params;
      sendtype = 1;
      params = {
        mobile: mobile,
        code: code,
        password: password,
        sendtype: sendtype,
        org_code: org_code
      };
      this.handleForgot(params).then(function (res) {
        var msg = res.errorMsg;

        if (res.result === 0) {
          _this4.$Message.success(msg);

          _this4.back();
        } else {
          _this4.$Message.error(msg);
        }
      });
    },
    submit1: function submit1() {
      var _this5 = this;

      var emailData = this.formEmail;
      var params;
      var sendtype = 2;
      params = {
        email: emailData.email,
        code: emailData.code,
        password: emailData.password,
        sendtype: sendtype
      };
      this.handleForgot(params).then(function (res) {
        var msg = res.errorMsg;

        if (res.result === 0) {
          _this5.$Message.success(msg);

          _this5.back();
        } else {
          _this5.$Message.error(msg);
        }
      });
    },
    handleSubmit: function handleSubmit(name) {
      var _this6 = this;

      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this6.submit();
        } else {
          _this6.$Message.error(_this6.$t('loginArea.requireFieldsNotice'));
        }
      });
    },
    handleSubmit1: function handleSubmit1(name) {
      var _this7 = this;

      this.$refs[name].validate(function (valid) {
        if (valid) {
          _this7.submit1();
        } else {
          _this7.$Message.error(_this7.$t('loginArea.requireFieldsNotice'));
        }
      });
    }
  }),
  mounted: function mounted() {},
  created: function created() {
    var vm = this; // if(this.edit){
    //   debugger
    //   vm.formMoblie.mobile = vm.userInfoStore.mobile_phone;
    //   vm.formEmail.email = vm.userInfoStore.email;
    // }
  }
};